export const SUCCESS_MESSAGE = "Record has been saved successfully!";
export const UNDELETE_MESSAGE = "Record has been undeleted successfully!";
export const DELETE_MESSAGE = "Record has been deleted successfully!";
export const CLEANUP_MESSAGE = "Customer Cleaned successfully!";
export const ERROR_EXISTS = "Data already exists!";
export const ERROR_MESSAGE = "Something went wrong!";
export const NECESSARY_FIELD = "Please fill all Below Field- ";
export const ALREADY_EXIST = " already exist!"; // before space concate name of the field
export const DATA_EXPORT = "Data exported successfully!";

export const ALL_NECESSARY_FIELD = "Personal Details, Address and Account Balance are mandatory field!"

// AWS Details
export const REACT_APP_AWSAccessKeyId = "AKIAUFIJLVSNAVMR2TFW";// "AKIA435OP3722G24SQ6B";
export const REACT_APP_AWSSecretKey = "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";//"Rr25AGMOWMMRnBoiPQiqxdwio/ktyqoCoxa4APds";
export const REACT_APP_Bucket = "omishjarkan";//"sonarposdev";
export const REACT_APP_REGION = "ap-south-1";//"us-west-1";
export const AWS_IMAGE_FOLDER_CATEGORIES = "CATEGORIES";
export const AWS_IMAGE_FOLDER_CUSTOMER = "CUSTOMERS";
export const AWS_IMAGE_FOLDER_EMPLOYEES = "EMPLOYEES";
export const AWS_IMAGE_FOLDER_SUPPLIERS = "SUPPLIERS";
export const AWS_IMAGE_FOLDER_DELIVERIES = "DELIVERIES";
// export const AWS_IMAGE_FOLDER_LOCATIONS = "LOCATIONS";
// export const AWS_IMAGE_FOLDER_STORECONFIG = "STORECONFIG";
export const AWS_IMAGE_FOLDER_WORKORDERS = "WORKORDERS";
export const AWS_IMAGE_FOLDER_ITEMS = "ITEMS";
// export const AWS_IMAGE_FOLDER_ITEMKITS = "ITEMKITS";
export const AWS_IMAGE_FOLDER_SALES = "SALES";
export const AWS_IMAGE_FOLDER_RECEIVING = "RECEIVING";

